import { VoucherBannerVariant } from './VoucherBanner.types'

export const VOUCHER_CAMPAIGN_ID: Record<VoucherBannerVariant, string> = {
  smava: 'dd5c26c9-5acf-42b1-90da-f00b44c416af',
  ffg: 'c5a04c21-c3e2-4a51-b41d-e4f2763ce4bf'
}

export const VOUCHER_ACTIVATION_BANNER_ID = 'voucher-activation-banner'

export const RCE_VOUCHER_CAMPAIGN_ID = '43b0c607-9a79-48b1-8074-a192daadb603'

export const RCE_VOUCHER_ACTIVATED_NOTICE_PAGES: ReadonlyArray<string> = [
  'editPage_additional',
  'edit_dac'
]

export const VOUCHER_TERMS_URL: Record<VoucherBannerVariant, string> = {
  smava: 'https://legal-docs.smava.de/voucherTerms.pdf',
  ffg: 'https://legal-docs.finanzcheck.de/voucherTerms.pdf'
}

export const VOUCHER_ACTIVATED_TITLE = (amount: number | null) => {
  return amount != null
    ? `Ihr ${amount} € Gutschein ist aktiviert!`
    : 'Ihr Gutschein ist aktiviert!'
}
